import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response) => {
    switch (method) {
        case handlers.INIT:
            if (
                response.result !== resultCodes.RESULT_OK &&
                response.result !== resultCodes.RESULT_INVALID_DATABASE_NAME &&
                response.result !== resultCodes.RESULT_DATABASE_UPDATE_NEEDED &&
                response.result !== resultCodes.RESULT_DATABASE_CANNOT_BE_USED &&
                response.result !== resultCodes.RESULT_DATABASE_AUTOLOGIN_FAILED
            ) {
                return [messageHelper.getFlashMessage(response), {type: actionTypes.SOFTWARE_INITIALIZED}];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_DATABASES_LIST,
                        params: {
                            all: true
                        }
                    },
                    method: handlers.GET_ALL_DATABASES_LIST,
                    tabId: 0
                }
            ];
        case handlers.GET_ALL_DATABASES_LIST:
            if (!responseHelper.isGetDatabasesListFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let databaseRequests = [
                {
                    type: actionTypes.SAVE_ALL_DATABASE_LIST,
                    payload: {
                        databaseList: response.data
                    }
                }
            ];

            if (
                responseHelper.needAnyDatabaseUpdate(response.data) ||
                !responseHelper.isAnyDatabaseAvailable(response.data)
            ) {
                return [
                    ...databaseRequests,
                    {
                        type: actionTypes.DATABASE_NOT_AVAILABLE
                    },
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            return [
                ...databaseRequests,
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_SERVER_VERSION
                    },
                    method: handlers.GET_SERVER_VERSION,
                    tabId: 0
                }
            ];
        case handlers.GET_ALL_DATABASES_LIST_AND_SKIP_UPDATE:
            if (!responseHelper.isGetDatabasesListFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let databaseListRequests = [
                {
                    type: actionTypes.SAVE_ALL_DATABASE_LIST,
                    payload: {
                        databaseList: response.data
                    }
                }
            ];

            if (responseHelper.isAnyDatabaseAvailable(response.data)) {
                return [
                    ...databaseListRequests,
                    {
                        type: actionTypes.DATABASE_AVAILABLE
                    },
                    {
                        type: actionTypes.SOFTWARE_NOT_INITIALIZED
                    },
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_SERVER_VERSION
                        },
                        method: handlers.GET_SERVER_VERSION,
                        tabId: 0
                    }
                ];
            }

            return [
                ...databaseListRequests,
                {
                    type: actionTypes.DATABASE_NOT_AVAILABLE
                },
                {
                    type: actionTypes.SOFTWARE_INITIALIZED
                }
            ];
        case handlers.GET_SERVER_VERSION:
            if (response.result === resultCodes.RESULT_REDLIKE_DATA_NOT_AVAILABLE) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.DATABASE_NOT_AVAILABLE
                    },
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            if (!responseHelper.isGetServerVersionFormatValid(response)) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.DATABASE_AVAILABLE
                    },
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            if (!responseHelper.checkServerVersion(response)) {
                return [
                    {
                        type: actionTypes.DATABASE_AVAILABLE
                    },
                    {
                        type: actionTypes.SERVER_NOT_COMPATIBLE
                    },
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            if (!responseHelper.checkDatabaseCompatability(response)) {
                return [
                    {
                        type: actionTypes.DATABASE_AVAILABLE
                    },
                    {
                        type: actionTypes.SERVER_COMPATIBLE
                    },
                    {
                        type: actionTypes.DATABASE_NOT_COMPATIBLE
                    },
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            return [
                {
                    type: actionTypes.DATABASE_AVAILABLE
                },
                {
                    type: actionTypes.SERVER_COMPATIBLE
                },
                {
                    type: actionTypes.DATABASE_COMPATIBLE
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_LOGGED_USER
                    },
                    method: handlers.GET_LOGGED_USER,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ACTIVE_DATABASE
                    },
                    method: handlers.GET_ACTIVE_DATABASE,
                    tabId: 0
                }
            ];
        case handlers.GET_ACTIVE_DATABASE:
            if (!responseHelper.isGetActiveDatabaseFormatValid(response)) {
                return [
                    {
                        type: actionTypes.SAVE_ACTIVE_DATABASE,
                        payload: {
                            database: modelHelper.mapDatabaseToObject(null)
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            if (window.imageStore.dbImageIsEmpty(response.data.name)) {
                return [
                    {
                        type: actionTypes.SAVE_ACTIVE_DATABASE,
                        payload: {
                            database: modelHelper.mapDatabaseToObject(response.data)
                        }
                    },
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_DATABASE_IMAGE,
                            params: {
                                name: response.data.name
                            }
                        },
                        method: handlers.GET_DATABASE_IMAGE,
                        tabId: 0
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_ACTIVE_DATABASE,
                    payload: {
                        database: modelHelper.mapDatabaseToObject(response.data)
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
